import { Component } from '@angular/core';
import {
  trigger,
  transition,
  style,
  animate
} from '@angular/animations';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-contenedor-reg-log',
  templateUrl: './contenedor-reg-log.component.html',
  styleUrls: ['./contenedor-reg-log.component.scss'],
  animations: [
    trigger('fadeSlide', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate('300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ opacity: 0, transform: 'translateY(-20px)' }))
      ])
    ])
  ]
})
export class ContenedorRegLogComponent {
  is_login: boolean = true;
  url: string = environment.configUrl;;
  conf: any;

  constructor(private modalRef: NgbActiveModal,
    private http: HttpClient) {
    this.http.get(this.url).subscribe((res: any) => {
      console.log(res)
      this.conf = res;
    });
  }


  toggleForm() {
    this.is_login = !this.is_login;
  }
  cerrarModal(evento) {
    if (evento) {
      this.modalRef.close();
    }
  }

}